
import { useTakeMealtModel } from "../takeMealtModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

export function PageHeader() {
    const {
        searchParam, userList,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useTakeMealtModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "预定人员",
            fieldName: "userId",
            size: "small",
            options: userList
        },
        {
            type: SearchTypeEnum.Datepicker,
            span: 4,
            placeholder: "带餐时间",
            fieldName: "appointTime",
            size: "small",
        },
        {
            type: SearchTypeEnum.Datepicker,
            span: 4,
            placeholder: "预约时间",
            fieldName: "createTime",
            size: "small",
        },
    ]
    return (
        <YhPageHeader
            title="外带餐品统计"
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}